module.exports = __webpack_public_path__ + "static/media/CodeStar-Icon-White.83f45877.svg";